export class XHRNot200StatusError extends Error {
  constructor(message: string) {
    super()

    this.message = message?.length ? message : "Попробуйте еще раз."
  }
}
